// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f2449203","453":"2342bb35","455":"f3f09478"}[chunkId] + ".chunk.js";
};